import React, {useCallback, useContext, useEffect, useState} from "react";
import {ProjectsContext} from "../../App";
import Gallery from "../Gallery/Gallery";
import {loadDataWithCache} from "../../utils";
import './style.scss';

const projectSections = [
    {key: 'cinematography', path: 'cinematography'},
    {key: 'directing', path: 'directing'},
    {key: 'dance', path: 'dance'},
    {key: 'exhibitions', path: 'exhibitions'},
];

const shuffle = items => [...items].sort(() => Math.random() - 0.5);

const ExploreMore = ({currentProject, section}) => {
    const {imagesCache, setImagesCache} = useContext(ProjectsContext);
    const [projects, setProjects] = useState([]);

    const getProjects = useCallback(async () => {
        setProjects([]);

        const sections = section
            ? projectSections.filter(item => item.key === section)
            : projectSections;
        const loaded = await Promise.all(sections.map(async item => {
            const images = await loadDataWithCache(`${item.key}-main`, imagesCache, setImagesCache);
            return images.map(image => ({...image, section: item.path}));
        }));
        const available = loaded.flat().filter(image => {
            const name = image?.context?.custom?.name;
            return name && name !== currentProject && image?.context?.custom?.caption;
        });

        setProjects(shuffle(available).slice(0, 4));
    }, [currentProject, imagesCache, section, setImagesCache]);

    useEffect(() => {
        getProjects();
    }, [getProjects]);

    if (projects.length === 0) return null;

    return (
        <section className="explore-more">
            <h2>Explore more</h2>
            <Gallery
                images={projects}
                isProjectCover={true}
                route={projects[0].section}
            />
        </section>
    );
};

export default ExploreMore;
